export const getSourceSystem = (organizationRole) => {
  const sources = organizationRole.sources.map((s) => s.mdmReference.sourceSystem);
  // Just to be sure - Ins has priority
  return sources.find((s) => s == 'Ins2000') ?? sources[0];
};
